import React from 'react';
import { TableRow, Tooltip } from '@mui/material';
import { TableCellBody } from '../../table/tableCell';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store/appStore';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';interface TableRowItemProps {
    row: any;
    onEditClick: (row: any) => void;
    onDeleteClick: (userId: string) => void;
    handleClick: (row: any) => void;
}

const TableRowItem: React.FC<TableRowItemProps> = ({ row, onEditClick, onDeleteClick, handleClick }) => {
    const association_type = useSelector((state: RootState) => state.projects.association_type);
    const association_type_vendor = association_type && association_type === 'VENDOR';
    const formatDate = (dateString: string) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }).format(date);
    };

    function formatMinutes(minutes: number) {
        const hrs = Math.floor(minutes / 60);
        const min = Math.floor(minutes);
        const sec = Math.round((minutes - min) * 60);
        return <span>{hrs > 0 ? `${hrs}h ${min}m ${sec}s` : min > 0 ? `${min}m ${sec}s` : `${sec}s`}</span>
      
    }
    
    return (
        <TableRow
            key={row.expert_id}
            sx={{
                '&:last-child td, &:last-child th': { borderBottom: 0 },
            }}
        >
            <TableCellBody><div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} onClick={() => handleClick(row)}>
                {row.email}
                <div style={{ flex: 1 }}>
                    <KeyboardArrowRightIcon fontSize='small' sx={{ cursor: 'pointer' }} />
                </div>
            </div>
            </TableCellBody>
            <TableCellBody>{row.role ? row.role : '-'}</TableCellBody>
            <TableCellBody>{row.expert_name ? row.expert_name : '-'}</TableCellBody>
            <TableCellBody>{row.pseudo_name ? row.pseudo_name : '-'}</TableCellBody>
            <TableCellBody>{row.gigsource_id ? row.gigsource_id : '-'}</TableCellBody>
            <TableCellBody>{row.total_attempts}</TableCellBody>
            <TableCellBody>{row.pass_fail_status ? row.pass_fail_status : '-'}</TableCellBody>
            <TableCellBody>{row.start_time ? formatDate(row.start_time) : '-'}</TableCellBody>
            <TableCellBody>{row.final_score ? row.final_score : '0'}</TableCellBody>
            <TableCellBody>{row.percentage_score ? row.percentage_score : '0'}</TableCellBody>
            <TableCellBody>{row.time_taken_to_complete ? formatMinutes(row.time_taken_to_complete) : '-'}</TableCellBody>
            <TableCellBody>
                {["FAILED"].includes(row.pass_fail_status) && !association_type_vendor ?
                    <Tooltip title="This action will change the failed status, promote the expert, and allow direct task allocation." arrow>
                        <CheckCircleOutlineOutlinedIcon
                            sx={{ color: 'green', cursor: 'pointer', marginRight: '5px' }}
                            onClick={() => onDeleteClick(row.expert_id)}
                        />
                    </Tooltip> : '-'}
            </TableCellBody>
        </TableRow>
    );
};

export default TableRowItem;
